module.exports = __webpack_public_path__ + "img/zwsj.5d5798a0.png";